
export const generatorApiNm = {
  getGenerator: "/generator/getGenerator",
  insertGenerator: "/generator/insertGenerator",
  updateGenerator: "/generator/updateGenerator",
  updateGeneratorColumn: "/generator/updateGeneratorColumn",
  deleteGenerator: "/generator/deleteGenerator",
  updateFileName: "/generator/updateFileName",
  deleteFile: "/generator/deleteFile",
  uploadFile: "/generator/uploadFile"
}

export const generatorColNm = {
  GenId: "รหัส",
  GenCd: "รหัสเครื่อง GEN",
  Model: "รุ่น",
  Dscp: "รายละเอียด",
  IsActv: "Active",
  Rmk: "หมายเหตุ",
  ModDte: "วันที่แก้ไข",
  ModAccId: "ผู้แก้ไข",
}

export const initDialogData = {
  GenId: null,
  GenCd: '',
  Model: '',
  Dscp: '',
  Rmk: '',
  IsActv: 1,
  ModDte: null,
  ModAccId: 0,
  ModAcc: null
}

export const initFilterData = {
  IsActv: 1,
  GenCd: null,
}
